export default __webpack_public_path__ + "static/media/dice-img.d7985b23.webp";